import React from 'react'
import './add-note.css'

const AddNote = (props) => {
    return(
        <div className="add-note-wrapper">
            <div className="add-note-popup-box">
                <h4>Timesheet Note</h4>
                <textarea className="add-note-text-box" placeholder="Write a note regarding your timesheet. If you have a note about your schedule or availability please write that in Availablity Notes or send us an email." value={props.note} onChange={(e) => props.setNote(e.target.value)} />
                <div className="add-note-save-and-close" onClick={() => props.setNotesOpen(false)}>Save and Close</div>
            </div>
        </div>
    )
}
export default AddNote